// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__9MLUH","outline":"Button_outline__monpX","icon":"Button_icon__Zd50D"};